import { ErrorComponentProps } from '@tanstack/react-router';

import Scaffold from '@components/scaffold';

import RouteErrorBoundary from './components/route-error-boundary';

export const RootRouteErrorBoundary = ({
  error,
  reset,
}: ErrorComponentProps) => (
  <Scaffold>
    <RouteErrorBoundary error={error} reset={reset} />
  </Scaffold>
);

export default RouteErrorBoundary;
